import { createAction, createReducer } from 'redux-act'
import { LOCATION_CHANGE, push, replace } from 'react-router-redux'
import { combineReducers } from 'redux'
import { localStorageKey } from './storage-config'

export const BASE_NAME = '';
export const timezone = 'Europe/Tallinn';

export const fullUrl = (url) => (url);

export const fullPush = (url) => {
  return push(fullUrl(url));
};

export const fullReplace = (url) => {
  return replace(fullUrl(url));
};

let fallback = {};
export const saveConfig = (key, value) => {
  try {
    window.localStorage.setItem(`${localStorageKey}-${key}`, value);
  } catch(e) {
    fallback[key] = value;
  }
};

export const retrieveConfig = (key) => {
  try {
    return window.localStorage.getItem(`${localStorageKey}-${key}`);
  } catch(e) {
    return fallback[key];
  }
};

export const clearConfig = (key) => {
  try {
    window.localStorage.removeItem(`${localStorageKey}-${key}`);
  } catch(e) {
    delete fallback[key];
  }
};



export const actions = {
  setToken: createAction('set token', (token) => ({token})),
  clearToken: createAction('clear token'),
  setActiveShop: createAction('set active shop', (shopUrl, shopId) => ({shopUrl, shopId})),
  setActiveUser: createAction('set active user', (user) => ({user})),
  userLogout: createAction('USER_LOGOUT'),
  receiveConfig: createAction('receive config', config => (config)),
  setLanguage: createAction('set language', language => ({language})),
  setUILanguage: createAction('set UI language', language => ({language})),
};


const activePath = createReducer({
  [LOCATION_CHANGE]: (state, payload) => payload.pathname
}, null);

let defaultGratifyServer = 'https://gratify.eu/';

if(typeof GRATIFY_API !== 'undefined' && GRATIFY_API) {
  defaultGratifyServer = GRATIFY_API;
}

let pluginBundleUrl = null;
if(typeof PLUGIN_BUNDLE_URL !== 'undefined' && PLUGIN_BUNDLE_URL) {
  pluginBundleUrl = PLUGIN_BUNDLE_URL;
}

const base = createReducer({}, defaultGratifyServer);
const api = createReducer({}, `${defaultGratifyServer}api/`);
const auth = createReducer({}, `${defaultGratifyServer}api-auth/`);
const pluginBundle = createReducer({}, pluginBundleUrl);
const token = createReducer({
  [actions.setToken]: (state, payload) => payload.token,
  [actions.clearToken]: () => null,
  [actions.userLogout]: () => null,
  [actions.receiveConfig]: (state, payload) => payload.config && payload.config.token ? payload.config.token : state,
}, retrieveConfig('token-new'));
const account = createReducer({}, null);
const language = createReducer({
  [actions.setLanguage]: (state, payload) => {
    return payload.language;
  }
}, retrieveConfig('language') || 'et');
const uiLanguage = createReducer({
  [actions.setUILanguage]: (state, payload) => {
    return payload.language;
  }
}, retrieveConfig('uiLanguage') || 'et');
const activeShop = createReducer({
  [actions.setActiveShop]: (state, payload) => payload.shopUrl
}, retrieveConfig('activeShop'));
const activeShopId = createReducer({
  [actions.setActiveShop]: (state, payload) => payload.shopId
}, retrieveConfig('activeShopId'));
const activeUser = createReducer({
  [actions.setActiveUser]: (state, payload) => payload.user
}, null);

export const reducer = combineReducers({
  activePath,
  base,
  api,
  auth,
  pluginBundle,
  token,
  account,
  language,
  uiLanguage,
  activeShop,
  activeShopId,
  activeUser
});

export const selector = state => state.config;
export const selectorWithLanguage = (configLanguageKey='language') => {
  return state => {
    return {
      ...state.config,
      configLanguageKey
    }
  };
};

export const translatedConfigSelector = selectorWithLanguage();
